import {
    addLayerToGisHierarchyItem,
    createGisHierarchyItem,
    getAllGisHierarchyItemsByHierarchyId,
} from "services/requests/v1/gishierarchyitem";

import {
    GoAiguaSelectOption,
    HierarchyItemType,
    SetRequestError,
    SetStateType,
    SubscribeContentType,
    UnsubscribeContentType,
} from "types/generic";
import { NodeType } from "components/adhoc/gistreecreatenewnode";

import { getFirstHierarchyGroupOnList } from "./components/gis-tree-hierarchy-functions";

type Params = {
    dropdownOptions: GoAiguaSelectOption[];
    selectedNodeType: NodeType;
    newNodeName: string;
    gisHierarchySelected: HierarchyItemType[];
    selectedOption: GoAiguaSelectOption;
    contentName: string;
    setsaveButtonStatus: SetStateType<"enabled" | "disabled">;
    closeModalFn: () => void;
    setNewNodeName: SetStateType<string>;
    setGisHierarchyId: SetStateType<HierarchyItemType[]>;
    setGisHierarchySelected: SetStateType<HierarchyItemType[]>;
    setSelectedOption: SetStateType<GoAiguaSelectOption>;
    setNameInputIsDisabled: SetStateType<boolean>;
    subscribeContent: SubscribeContentType;
    unsubscribeContent: UnsubscribeContentType;
    setError: SetRequestError;
};

export const gisTreeCreateNewNodeFunctions = ({
    dropdownOptions,
    gisHierarchySelected,
    newNodeName,
    selectedNodeType,
    selectedOption,
    contentName,
    setsaveButtonStatus,
    closeModalFn,
    setGisHierarchyId,
    setGisHierarchySelected,
    setNewNodeName,
    setSelectedOption,
    setNameInputIsDisabled,
    setError,
    subscribeContent,
    unsubscribeContent,
}: Params) => {
    const handleDropdownSelectionChange = (selectedId: string) => {
        const newSelectedOption = dropdownOptions.find(
            (dropdownOption) => dropdownOption.value === selectedId
        );
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
            setsaveButtonStatus("enabled");
        }
    };

    const createLayerDisabled = () => {
        if (gisHierarchySelected.length > 0) {
            return false;
        } else {
            return true;
        }
    };

    const handleCreateNewNode = async () => {
        const selectedGroup =
            getFirstHierarchyGroupOnList(gisHierarchySelected);
        subscribeContent(contentName);

        setsaveButtonStatus("disabled");
        setNameInputIsDisabled(true);

        try {
            if (selectedNodeType === "group") {
                if (selectedGroup) {
                    const newHierarchyItem = {
                        active: true,
                        name: newNodeName,
                        hierarchy: selectedGroup!.hierarchy,
                        parent: selectedGroup!.id as number,
                    };
                    await createGisHierarchyItem(newHierarchyItem);
                } else {
                    const newHierarchyItem = {
                        active: true,
                        name: newNodeName,
                        hierarchy: 1,
                        parent: null,
                    };
                    await createGisHierarchyItem(newHierarchyItem);
                }
            } else {
                if (selectedGroup) {
                    await addLayerToGisHierarchyItem(
                        selectedGroup!.id as number,
                        +selectedOption.value
                    );
                }
            }

            const { data } = await getAllGisHierarchyItemsByHierarchyId(1);
            setGisHierarchyId(data);
            setGisHierarchySelected([]);
            setNameInputIsDisabled(false);
            unsubscribeContent(contentName, true);
        } catch (error) {
            setError(contentName);
        }

        closeModalFn();
    };

    const handleTextInputChange = (inputText: string) => {
        setNewNodeName(inputText);
    };

    return {
        createLayerDisabled,
        handleDropdownSelectionChange,
        handleCreateNewNode,
        handleTextInputChange,
    };
};
